<span
  class="shift-plan-bubble"
  *ngIf="isVisible && (bubble.value !== 0 || bubble.showDot); else emptyBubble"
  [ngClass]="{
    'bubble-dot': bubble.showDot,
    bubble: !bubble.showDot && bubble.value > 0,
  }"
  [class]="isCalendar ? 'dark-blue shift-plan-bubble-calendar pointer' : 'primary'"
  (click)="bubbleClickHandler(bubble)"
>
  <span
    *ngIf="bubble.value > 0"
    class="bubble-content"
  >
    {{ bubble.value }}
  </span>
</span>

<ng-template #emptyBubble>
  <span
    class="shift-plan-bubble empty-bubble"
    [ngClass]="{ 'shift-plan-bubble-calendar pointer': isCalendar }"
    (click)="bubbleClickHandler(bubble)"
  ></span>
</ng-template>
